import React from 'react';
import PropTypes from 'prop-types';
import ConceptsList from './ConceptsList';
import SectionHeader from '../SectionHeader';

const SpecialBookTypeView = ({ kopItems }) => (
    <div className="comprehension-paragraphs wide">
        <SectionHeader titles={['Concept', 'Points']} />
        <ConceptsList kopItems={kopItems} />
        <div className="paragraph-holder right">
            <span>Total {kopItems.filter(item => item.groupCorrect).length}</span>
        </div>
    </div>
);

SpecialBookTypeView.defaultProps = {
    kopItems: [],
};

SpecialBookTypeView.propTypes = {
    kopItems: PropTypes.array,
};

export default SpecialBookTypeView;
